export var MESSAGE_REPOSITORY = 'MESSAGE_REPOSITORY';